import React from 'react';
import {Icon} from '../Icon';

const SelectableItem = ({ item, onClick, isSelected, isIcon, classNameIcon }) => {
  const handleClick = () => {
    onClick(item);
  };

  return (
    <li onClick={handleClick} className={isSelected ? 'selected' : ''}>
      {isIcon && <Icon typeIcon="squareFill" size="6px" className={classNameIcon} />}
      <div className="text">{item.text}</div>
    </li>
  );
};

export default SelectableItem;
